import React from 'react';

export const VikVText = () => {
  return <p>Клацніть лiвою кнопкою миші на значок і перетягніть на стіну внутрішню.</p>;
};
